import React from 'react';
import Footer from '../../common/Footer';

const AboutUsFooter = () => {
  return <Footer />;
};

export default AboutUsFooter;
